import {
	Component,
	OnInit
} from "@angular/core";
import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import { DestroyableComponentBase } from "apps/idl/src/modules/utils/components/destroyable-component-base";
import { CapacitorPluginScePlugin } from 'capacitor-plugin-sce';
import JSZip from 'jszip';
import { from } from "rxjs";
import { takeUntil, tap } from "rxjs/operators";
import { PlatformService } from "../../../../../services/security";
import { SceFactory } from "../../../sce4Mobile/sceFactory";
import { EDebugLevelSCE } from "../../enums/EDebugLevelSCE";
import { EDeviceType } from "../../enums/EDeviceType";
import { DeviceService } from "../../services/device.service";
import { DrawerPopoverService } from "../../services/drawer-popover.service";
import { LoaderService } from "../../services/loader.service";
import { SnackbarService } from "../../services/snackbar.service";
import { ChoixLevelDebugSCEComponent } from "../choix-level-debug-sce/choix-level-debug-sce.component";
import { ConfirmationSuppressionComponent } from "../confirmation-suppression/confirmation-suppression.component";



@Component({
	selector: "di-menu-sce-logs",
	templateUrl: "./menu-sce-logs.component.html",
	styleUrls: ["./menu-sce-logs.component.scss"],
})
export class MenuSCELogsComponent extends DestroyableComponentBase implements OnInit {

	public showPopover: boolean = false;
	public isMobile: boolean = false;
	public sceDebug = false;	

	public pluginSce : CapacitorPluginScePlugin;
	

	constructor(
		private svcDrawerPopover: DrawerPopoverService,
		private svcDevice: DeviceService,
		private svcSnackbar : SnackbarService,
		private svcLoader : LoaderService,
		private svcPlatform : PlatformService
	) {
		super();
	}

	ngOnInit() {
		this.svcDevice.isMobile$.pipe(takeUntil(this.destroyed$)).subscribe((flag: boolean) => {
			this.isMobile = flag;
		});

		const deviceTypeUser: EDeviceType = this.svcPlatform.getDeviceType();
		this.pluginSce = SceFactory.getSceInstance(deviceTypeUser)
		from(this.pluginSce.getStatus()).pipe(
			tap(status => {
				this.sceDebug = status.debug;
			})
		).subscribe();	
}

	async handleActiveDebug(event: Event) {

		if(this.sceDebug)
		{
			await this.pluginSce.setDebug({debug: false})
			this.sceDebug = false;
			this.closeMenu();
			return;
		}
		this.showPopover = true;
		this.svcDrawerPopover.open(
			"Choix du niveau de debug",
			"auto",
			event.currentTarget,
			ChoixLevelDebugSCEComponent,
			{
				onConfirm: (debugLevel: EDebugLevelSCE) => this.handleConfirmDebug(debugLevel),
				onCancel: () => this.closeMenu(),
			},
			() => (this.showPopover = false)
		);
	}

	async handleDownloadLogsClick(event: Event) {
    event.preventDefault();
		
		this.svcLoader.showLoader("Export des logs encours...");
    try {
      const dir = await Filesystem.readdir({
        path: 'logs',
        directory: Directory.Data,
      });

      if (!dir.files.length) {
        return;
      }
      const zip = new JSZip();

      for (const fileInfo of dir.files) {
				const fileName = fileInfo.name;

				const file = await Filesystem.readFile({
					path: `logs/${fileName}`,
					directory: Directory.Data,
					encoding: Encoding.UTF8, 
				});

				let content: Uint8Array;

				if (typeof file.data === 'string') {
					content = new TextEncoder().encode(file.data);
				} else if (file.data instanceof Blob) {
					content = new Uint8Array(await file.data.arrayBuffer());
				} else {
					throw new Error('Format de fichier inconnu');
				}
				zip.file(fileName, content);
			}

      const zipBase64 = await zip.generateAsync({ type: 'base64' });
      const zipFileName = `logs_${new Date().toISOString().replace(/[:.]/g, '-')}.zip`;

      await Filesystem.writeFile({
        path: zipFileName,
        data: zipBase64,
        directory: Directory.Documents,
      });
				const pathExport = `Download/`;
				this.svcSnackbar.showToast(
					"success",
					"bottom center",
					`Export des logs réussi dans le dossier : ${pathExport}`,
					null, null, null, "5000");
			} catch (err) {
				this.svcSnackbar.showToast(
						"error",
						"bottom center",
						"Erreur lors de la création du ZIP.",
						null, null, null, "5000"
				);
    	}	finally {
					this.svcLoader.hideLoader();
			}
  }

	handleSupprimerClick(event: Event) {			
		this.showPopover = true;
		this.svcDrawerPopover.open(
			"Confirmation de suppression",
			"auto",
			event.currentTarget,
			ConfirmationSuppressionComponent,
			{
				onConfirm: () => this.handleConfirmSuppression(),
				onCancel: () => this.closeMenu(),
			},
			() => (this.showPopover = false)
		);
	}


	async handleConfirmSuppression() {
		await this.pluginSce.eraseLogFiles()
		this.closeMenu()
	}

	async handleConfirmDebug(debugLevel: EDebugLevelSCE) {
		await this.pluginSce.setDebug({debug: true,level:debugLevel})
		this.sceDebug = true;

		this.closeMenu()
	}


	public closeMenu(): void {
		this.showPopover = false;
		this.svcDrawerPopover.close();
	}
}
